module.exports = __webpack_public_path__ + "static/media/Pedro.6bd9d932.jpg";